import React from 'react';
import Alert from "../ui/Alert";

export default function ProfilePhotoCard(props) {
    const [currentPassword, setCurrentPassword] = React.useState('');
    const [newPassword, setNewPassword] = React.useState('');
    const [confirmPassword, setConfirmPassword] = React.useState('');
    const [alertNotification, setAlertNotification] = React.useState({type: null, text: null});


    const onSubmit = (e) => {
        e.preventDefault();

        if (newPassword !== confirmPassword) {
            setAlertNotification({
                type: 'danger',
                text: 'New passwords don\'t match.'
            });

            return false;
        }

        if (newPassword === currentPassword) {
            setAlertNotification({
                type: 'danger',
                text: 'New password cannot be the same as the current password.'
            });

            return false;
        }

        props.usersRequests.changePassword(currentPassword, newPassword).then((response) => {
            if (response !== false) {
                setAlertNotification({
                    type: 'success',
                    text: 'Password changed successfully.'
                });

                setCurrentPassword('');
                setNewPassword('');
                setConfirmPassword('');
            } else {
                setAlertNotification({
                    type: 'danger',
                    text: 'Password change failed.'
                });
            }
        });
    }


    const onCancel = (e) => {
        e.preventDefault();

        setCurrentPassword('');
        setNewPassword('');
        setConfirmPassword('');
    }


    return (
        <div className="card w-100 position-relative overflow-hidden">
            <div className="card-body p-4">
                <h5 className="card-title fw-semibold">{'Change Password'}</h5>
                <p className="card-subtitle mb-4">{'To change your password, please confirm here.'}</p>

                {alertNotification.text && (
                    <Alert
                        type={alertNotification.type}
                        text={alertNotification.text}
                        onHide={() => {setAlertNotification({type: null, text: null})}}
                    />
                )}

                <form>
                    <div className="mb-4">
                        <label htmlFor="exampleInputPassword1" className="form-label fw-semibold">{'Current Password'}</label>
                        <input type="password" className="form-control" id="exampleInputPassword1" value={currentPassword} onChange={(e) => {setCurrentPassword(e.target.value)}} />
                    </div>
                    <div className="mb-4">
                        <label htmlFor="exampleInputPassword1" className="form-label fw-semibold">{'New Password'}</label>
                        <input type="password" className="form-control" id="exampleInputPassword1" value={newPassword} onChange={(e) => {setNewPassword(e.target.value)}} />
                    </div>
                    <div className="">
                        <label htmlFor="exampleInputPassword1" className="form-label fw-semibold">{'Confirm Password'}</label>
                        <input type="password" className="form-control" id="exampleInputPassword1" value={confirmPassword} onChange={(e) => {setConfirmPassword(e.target.value)}} />
                    </div>
                    <div className="">
                        <div className="d-flex align-items-center justify-content-end mt-4 gap-3">
                            <button className="btn btn-primary" onClick={onSubmit}>{'Save'}</button>
                            <button className="btn btn-light-danger text-danger" onClick={onCancel}>{'Cancel'}</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
}